<template>
  <div class="py-36 h-full">
    <div class="w-11/12 m-auto my-24">
      <h1 class="text-center about text-9xl main-color">Coming Soon</h1>
      <p class="text-center my-10 text-2xl">The page you are currently looking for is unavailable as of this moment. <br>  </p>
      <span class="w-full flex items-center justify-center">
        <vs-icon class="animate__animated animate__rubberBand animate__delay-1s" icon="sentiment_satisfied_alt" size="75px" color="black"></vs-icon>
      </span>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>